export function concatReducer<T>(accumulator: T[], currentValue: T[]): T[] {
    accumulator.push(...currentValue);
    return accumulator;
}
